module.exports = __webpack_public_path__ + "img/Pegi45.b3db0c49.png";